import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"
 
const Head = (props) =>{

	const query = useStaticQuery(graphql`
	  query {
		  site(siteMetadata: {}) {
		    id
		    siteMetadata {
		      title
		    }
		  }
	  }
	`)

	return(
	    <Helmet
	        htmlAttributes={{
	            lang: 'ja',
	        }}
		    bodyAttributes={{
		        class: "notosans"
		    }}
			title = {`${props.title} ${query.site.siteMetadata.title}`}
	        meta = {[
				{ charset: 'UTF-8'},
				{ name: 'viewport', content: 'width=device-width, initial-scale = 1.0, maximum-scale = 1.0, user-scalable=no'},
	            { name: 'keywords', content: props.keywords },
	            { name: 'description', content: props.description },
	            { property: 'og:title', content: props.title+" "+query.site.siteMetadata.title},
	            { property: 'og:type', content: props.type },
	            { property: 'og:url', content: props.url },
	            { property: 'og:image', content: '' },
	            { property: 'og:site_name', content:props.title+" "+query.site.siteMetadata.title},
	            { property: 'twitter:card', content: props.url },
	            { property: 'twitter:site', content: props.url },
				{ property: 'twitter:domain', content: 'japanlaim.com'},
				{ property: 'twitter:title', content: props.title+" "+query.site.siteMetadata.title},
				{ property: 'twitter:image', content: ''},
				{ property: 'image', content: ''}
	        ]}
	        /* All in One SEO Pack 2.4.5.1 by Michael Torbert of Semper Fi Web Design[303,334] */
	        link = {[
				/* Style */
				//
			    /* Fonts */
			    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700'},
			    { rel: 'stylesheet', href: 'https://use.fontawesome.com/releases/v5.6.3/css/all.css'}
	        ]}
	        /*	
			  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
			  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
			  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
			  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

			  ga('create', 'UA-8616970-1', 'auto');
			  ga('send', 'pageview');
	        */ 
	    />
	)

}

export default Head